export enum BookOwnership {
  ASSIGNMENT_GRP = 'ASSIGNMENT_GRP', // 서평단(필사단)
  RENTAL = 'RENTAL', // 대여
  GIFTED = 'GIFTED', // 선물받은책
  PURCHASED = 'PURCHASED', // 구매한책
  ETC = 'ETC' // 기타
}

export enum BookStatus {
  PLAN_TO_READ = 'PLAN_TO_READ', // 읽을책
  READING = 'READING', // 읽는중
  DONE_TO_READ = 'DONE_TO_READ' // 읽은책
}

export enum ScriptStatus {
  PLAN_TO_SCRIPT = 'PLAN_TO_SCRIPT', // 필사할책
  SCRIPTING = 'SCRIPTING', // 필사중
  DONE_TO_SCRIPT = 'DONE_TO_SCRIPT' // 필사한책
}

export enum RecordType {
	READING = 'READING', //독서 
	SCRIPTING = 'SCRIPTING' //필사  
}

export enum BookRegType {
  NUBOOK = 'NUBOOK', // 누북
  MOIM = 'MOIM', // 모임
  RECRUIT = 'RECRUIT', // 모집
}

export enum AcceptMethod {
	ADMIN_APPROVAL = 'ADMIN_APPROVAL', //관리자 승인
	FIRST_COME_FIRST_SERVED = 'FIRST_COME_FIRST_SERVED', //선착순
	AUTO_APPROVAL = 'AUTO_APPROVAL' //자동 승인	
}

export enum BookEventType {
	RECRUIT_REVIEWER = 'RECRUIT_REVIEWER', //서평단 
	RECRUIT_SCRIPTER = 'RECRUIT_SCRIPTER', //필사단  
	ETC = 'ETC' //기타 
}

export enum ApplicantStatus {
	APPLY = 'APPLY', //신청  
	ACCEPTED = 'ACCEPTED', // 수락  
	REJECTED = 'REJECTED', // 거절 
	CANCEL = 'CANCEL' //신청취소   
}

export enum CommunityApplicantStatus {
	APPLIED = 'APPLIED', //신청
	APPROVED = 'APPROVED', //승인
	REJECTED = 'REJECTED', //탈락
	CANCELLED = 'CANCELLED', //신청취소
	WITHDRAWN = 'WITHDRAWN', //탈퇴
}

export enum CommunityBoardType {
	DEFAULT = 'DEFAULT', //자유게시판
	ETC = 'ETC', //기타
}

export enum CommunityType {
	ONLINE = 'ONLINE', //온라인
	OFFLINE = 'OFFLINE', //오프라인
}

export enum ActivityType {
	BOOK_REVIEW = 'BOOK_REVIEW', //서평
	BOOK_SCRIPT = 'BOOK_SCRIPT', //필사
	ETC = 'ETC' //기타
}

export enum MeetingType {
	ONLINE = 'ONLINE', //온라인
	OFFLINE = 'OFFLINE', //오프라인
}

export enum NoobookRole {
	ADMIN = 'ADMIN',
	PROFESSIONAL = 'PROFESSIONAL', //프로형  
	LEADER = 'LEADER', //리더형  
	COMMUNITY = 'COMMUNITY', //참여형  
	PERSONAL = 'PERSONAL', //개인형 
	FREEUSER = 'FREEUSER' //무료회원
}


export enum BannerType {
	MAIN = 'MAIN',
	SUB_1 = 'SUB_1',
	SUB_2 = 'SUB_2',
	SUB_3 = 'SUB_3',
}
